import { SaveSlackIntegrationInput3jeifrdutkqgi as SaveSlackIntegrationInput } from './schema/type/SaveSlackIntegrationInput.mjs';
import { SaveSlackIntegrationMutation39ifsawios99y as SaveSlackIntegrationMutation } from './schema/SaveSlackIntegrationMutation.mjs';
import { toVoidResult8ga34bq1f52r as toVoidResult } from './SdkGrantSlackAccess.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function saveSlackIntegrationInput($this, $receiver) {
  var tmp0_team = $receiver.s2k_1;
  var tmp1_channel = $receiver.r2k_1;
  var tmp2_partyId = $receiver.q2k_1;
  return new (SaveSlackIntegrationInput())(tmp2_partyId, tmp0_team, tmp1_channel);
}
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.a6u(new (SaveSlackIntegrationMutation())(saveSlackIntegrationInput(this, command)), $completion)).d42_1;
  return toVoidResult(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w6h_1);
}
var SdkSaveSlackIntegrationCommandDispatcherClass;
function SdkSaveSlackIntegrationCommandDispatcher() {
  if (SdkSaveSlackIntegrationCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSaveSlackIntegrationCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSaveSlackIntegrationCommandDispatcherClass = $;
  }
  return SdkSaveSlackIntegrationCommandDispatcherClass;
}
//region block: exports
export {
  SdkSaveSlackIntegrationCommandDispatcher as SdkSaveSlackIntegrationCommandDispatcher1t7cxnysmjc4h,
  perform as performq4a2arsdobnz,
};
//endregion

//# sourceMappingURL=SdkSaveSlackIntegrationCommandDispatcher.mjs.map
